import factory from './icon';
import Svg12x12 from './glyphs/Trash_12x12.svg';
import Svg16x16 from './glyphs/Trash_16x16.svg';

export const Trash12x12 = factory(Svg12x12, 12, 12);
export const Trash16x16 = factory(Svg16x16, 12, 12);
